// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-attachment {\n  background: white;\n  padding: 0.8rem 1rem;\n}\n.table-attachment--top-attached {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.table-attachment--bottom-attached {\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  box-shadow: 0 1.2px 2px rgba(0, 0, 0, 0.2);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
